import React from 'react';
import { Button, Stack } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const encodePath = (parts) => `/${parts.map((part) => encodeURIComponent(part)).join('/')}`;

export default function MonitorNavigation({ compact = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { bu = '', plant = '', factory = '' } = useParams();
  if (!bu || !plant || !factory) return null;

  const base = encodePath([bu, plant, factory, 'WIP Tracking']);
  const links = [
    { label: 'Register', path: base },
    { label: 'Mobile Scan', path: `${base}/mobile-scan` },
    { label: 'Warehouse', path: `${base}/low-care` },
    { label: 'Raw Mat', path: `${base}/raw-mat` },
    { label: 'WIP', path: `${base}/wip` },
    { label: 'FG', path: `${base}/fg` },
    { label: 'In-Line Monitor', path: `${base}/in-line-monitor` },
  ];

  return (
    <Stack direction="row" useFlexGap spacing={1} sx={{ mb: compact ? 1 : 2, flexWrap: 'wrap', pb: 0.5 }}>
      {links.map((link) => (
        <Button
          key={link.path}
          size="medium"
          variant={decodeURI(location.pathname) === decodeURI(link.path) ? 'contained' : 'outlined'}
          onClick={() => navigate(`${link.path}${location.search}`)}
          aria-current={decodeURI(location.pathname) === decodeURI(link.path) ? 'page' : undefined}
          sx={{
            flexShrink: 0, minHeight: compact ? 40 : 48, px: compact ? 1.5 : 2, py: compact ? 0.5 : 1,
            fontSize: '18px', fontWeight: 600, lineHeight: 1.4,
            textTransform: 'none', letterSpacing: 'normal', whiteSpace: 'nowrap',
          }}
        >
          {link.label}
        </Button>
      ))}
    </Stack>
  );
}

